import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/landing';
export function Bonuses() {
  return <section className="bg-navy-950 py-16 text-white sm:py-24" aria-labelledby="bonuses-title" data-id="element-76" data-mp="1ckwngh3iixq5">
      <div className="mx-auto max-w-5xl px-3 sm:px-5" data-id="element-77" data-mp="18jkr7sq4ve8z">
        <div className="px-2 text-center" data-id="element-78" data-mp="18l5pntfkjhc4">
          <span className="inline-flex items-center gap-2 rounded-full bg-ember-500 px-4 py-2 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-79" data-mp="259lflqmlbspr">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="20ba4zdoh1e6h" />
            Exclusive bonuses — free
          </span>
          <h2 id="bonuses-title" className="mx-auto mt-5 max-w-3xl text-balance font-display text-[2rem] font-black leading-tight sm:text-5xl" data-id="element-81" data-mp="1wb9qjt1dh2zf">
            Today, You’ll Also Get These <span className="text-brand-400" data-id="element-82" data-mp="krnjodtpv8do">5 Exclusive Bonuses</span>
          </h2>
          <p className="mt-4 text-lg text-white/80" data-id="element-83" data-mp="fx03d28v9ka6">
            Total Bonus Value: <s className="text-white/60" data-id="element-84" data-mp="1euydu4nkgdcb">$197</s>{' '}
            <strong className="text-ember-400" data-id="element-85" data-mp="1jsrmr5g97lga">— Included FREE Today</strong>
          </p>
        </div>

        <div className="mt-10 space-y-6 sm:space-y-8" data-id="element-86" data-mp="15t8n711idifl">
          {bonuses.map((bonus, i) => <article key={bonus.number} className="overflow-hidden rounded-3xl bg-white text-navy-900 lg:grid lg:grid-cols-2 lg:items-center" data-id="element-87" data-mp="1artcw6j4wjps" data-mpi={i}>
              <div className={`bg-white ${i % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-88" data-mp="w1cgj1lcwjzr">
                <img src={bonus.image} alt={`Bonus ${bonus.number}: ${bonus.title}`} className="block w-full" loading="lazy" data-id="element-89" data-mp="10v6x3w5o0ium" />
              </div>
              <div className="p-6 sm:p-8" data-id="element-90" data-mp="d4kyevhjwaxa">
                <div className="flex flex-wrap items-center gap-3" data-id="element-91" data-mp="d5mcz9xrzfjr">
                  <span className="rounded-lg px-3 py-1 text-sm font-black uppercase tracking-wide text-white" style={{
                backgroundColor: bonus.accent
              }} data-id="element-92" data-mp="i3xmtko2lq1z">
                    Bonus #{bonus.number}
                  </span>
                  <span className="text-sm font-bold text-navy-900/60" data-id="element-93" data-mp="2b09nj6ihbm3s">
                    Value: <s data-id="element-94" data-mp="2axvrovfz65v6">${bonus.value}</s>{' '}
                    <span className="rounded-md bg-cta-500 px-2 py-0.5 font-black text-white" data-id="element-95" data-mp="261ycwtkd17ki">FREE</span>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-[1.75rem] font-black leading-tight sm:text-3xl" data-id="element-96" data-mp="32pbkx8c1equd">{bonus.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-navy-900/75" data-id="element-97" data-mp="2tqrdj3bxg3lg">{bonus.description}</p>
                {bonus.items && <>
                    {bonus.listLabel && <p className="mt-5 text-sm font-extrabold uppercase tracking-wide" data-id="element-98" data-mp="1ibb322qvw7vb">{bonus.listLabel}</p>}
                    <ul className="mt-3 grid gap-x-5 gap-y-2 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2" data-id="element-99" data-mp="1dbg89o3zmy4z">
                      {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-navy-900/85" data-id="element-100" data-mp="187e5ir6yvh62">
                          <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                    color: bonus.accent
                  }} strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="1d70hkxb26rda" />
                          {item}
                        </li>)}
                    </ul>
                  </>}
              </div>
            </article>)}
        </div>

        <div className="px-2" data-id="element-102" data-mp="20w1js2tat6a4">
          <CtaButton className="mt-12" tone="dark" label="I want all 5 bonuses free" data-id="element-103" data-mp="20v9ybktf0oxk" />
        </div>
      </div>
    </section>;
}